import React from 'react';


import i_close from '../../UI/svg/Close.svg';


import i_loading from '../../UI/Cargando.png'
import i_back from '../../UI/back_simple.png';
import svg_loading from '../../UI/oval.svg'





class GaleriaComponent extends React.Component {



    constructor(props) {
        super(props);
        this.state = {
            
            statusGaleria: 'not rendered',
            indexRender: 0,
            isFirstImg: true,
            isLastImg: true,
            renders: []
            
        };
    }




    componentDidMount(){
        this.setState({statusGaleria:'loading'});

        let arrayMixed = []
        let {selectedPOI} = this.props;

        console.log(selectedPOI)
        
        /*solo si es un tipoapto*/
        if(selectedPOI.Niveles)
        {
            selectedPOI.Galeria.forEach(r => {
                arrayMixed.push({path: 'Galeria', img: r.Imagen});
            });

            selectedPOI.Planos.forEach(p => {
                arrayMixed.push({path: 'Planos',img: p.Imagen});
            });
            
        }
        else{
            
            /*if(selectedPOI.Nombre === 'Vías de acceso'){
                //console.log('Gallery loading amenidades ')
                arrayMixed.push({path: 'Amenidades', img: 'Images/FACHADA-PPAL-TIBABITA-CON-DIVISION_1080.jpg'});
                arrayMixed.push({path: 'Amenidades', img: 'Images/TIBABITA-TERRAZA-con-DIVISION_1080.jpg'});
            } else {
                selectedPOI.Galeria.forEach(r => {
                    //console.log(r.Imagen)
                    arrayMixed.push({path: 'Amenidades', img: r.Imagen});
                });
            }*/
            selectedPOI.Galeria.forEach(r => {
                arrayMixed.push({path: 'Amenidades', img: r.Imagen.substr(35, r.Imagen.length)}); // substring needed for amenities, this should not be necessary
                // TODO: check admin to see why amenities is returning a path that includes project
            });
            
        }

        //console.log('arraymixed: ',arrayMixed)

        this.setState({renders: arrayMixed});
    }

    componentDidUpdate( prevProps, prevState){
        
        
        let arrayMixed = []
        let {selectedPOI} = this.props;
        
    }


    handleImageLoaded = () => {
        //console.log('hey si, ya cargue')
        this.setState({ statusGaleria: "loaded" });
    }

    handlePrevGaleria = () =>
    {
        let {indexRender} = this.state;
        this.setState({indexRender: indexRender-1, statusGaleria:'loading'});
    }

    //precondicion: solo esta visible si hay algún siguiente
    handleNextGaleria = () =>
    {
        let {indexRender} = this.state;
        let {selectedPOI} = this.props;

        this.setState({indexRender: indexRender+1, statusGaleria:'loading'});

    }



    render()
    {

        
        let {selectedAptoTipo, selectedPOI, /*indexRender, *//*statusGaleria,*/ textures,
            /*handleImageLoaded,*/  handleCloseGaleria, /*handlePrevGaleria, handleNextGaleria*/} = this.props;
        let {statusGaleria, indexRender } = this.state;

        return (

                <div className="slide">

                    {/* para saber si es un tipo apto o Amenidades: */}
                    { selectedPOI.Niveles ?
                        <img className='slide-image' onLoad={this.handleImageLoaded.bind(this)}
                            // src={ selectedAptoTipo.Planos && textures[`Images/Planos/${selectedAptoTipo.Planos[indexRender].Imagen}`]  } />
                            src={ this.state.renders.length > 0 ? textures[`Images/${this.state.renders[indexRender].path}/${this.state.renders[indexRender].img}`] : undefined } />
                        :
                        <img className='slide-image' onLoad={this.handleImageLoaded.bind(this)}
                            src={ this.state.renders.length > 0 ? textures[`Images/${this.state.renders[indexRender].path}/${this.state.renders[indexRender].img}`] : undefined} />
                    }


                    {statusGaleria !== 'loaded'?
                     <div className="slide-loading"><img className="loader-circle"  src={ svg_loading } /> </div>
                     : <div></div> 
                    } 


                    {/* :
                        <svg className="loader-circle" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                            <circle className="internal-circle" cx="60" cy="60" r="50"></circle>
                        </svg>
                    } */}


                    <div className="slide-ui">
                        <button  className="slide-close" onClick={handleCloseGaleria}><img src={i_close}/></button>
                        {this.state.renders.length > 0 && this.state.renders[indexRender].path === 'Planos' && statusGaleria === 'loaded' ? 
                        <div className="slide-info">
                            <h3>Tipo de apartamento {selectedAptoTipo.Nombre}</h3>
                            <hr/>
                            {/* Área construida: 50 mts2 <br/>
                            Área privada : 50 mts2 <br/> */}
                            {selectedAptoTipo.Areas.map((  area , indexApto) =>
                                <div>{area.Nombre}: {area.Valor} </div>
                            )}
                        </div>:<div></div>}

                        {indexRender !== 0 ? 
                            <button className="slide-prev" onClick={this.handlePrevGaleria}> <img src={i_back}  /></button>
                            :<span></span>
                        }
                        {indexRender + 1 !== this.state.renders.length ? 
                             <button className="slide-next" onClick={this.handleNextGaleria}> <img src={i_back} /></button>
                             :<span></span>
                        }

                    </div>
                </div>
               
                
            

        );
    }
}

export default GaleriaComponent;